<template>
    <v-app> 
         <Tabs :routes='route' colors="#7414bf"/>
            <v-container>
                <transition name="slide-fade">
                 <router-view></router-view>
                </transition>
            </v-container>
            <Menu type="asignaciones"/>
    </v-app>
</template>
<script>

import Tabs from '../../component/layouts/content/tabs'
import Menu from '../../component/layouts/single'

export default {
    components:{
        Tabs,
        Menu
    },

    mounted() {
        this.GetAllTeam();
    },

    methods: {
        GetAllTeam:function(){
            this.$store.dispatch('LoadingAction');
            this.$store.dispatch('GetAllSelect');
            this.$store.dispatch('GetAsign');
        }
    },

    

    data(){
        return {

            route:[
                {
                    id:1,
                    name:'Ver las Asignaciones',
                    icon:'mdi-clipboard-text',
                    route:'/asignacion',
                    items: [
                        {
                        text: 'Inicio',
                        disabled: false,
                        href: '/',
                        },
                        {
                        text: 'asignaciones',
                        disabled: true,
                        href: 'asignacion',
                        },
                        
                    ],
                
                },

                {
                    id:2,
                    name:'Crear Asignación',
                    icon:'mdi-plus-circle',
                    route:'/asignacion/crear',
                    items: [
                        {
                        text: 'Inicio',
                        disabled: false,
                        href: '/',
                        },
                        {
                        text: 'Asignacion',
                        disabled: false,
                        href: '/asignacion',
                        },
                        {
                        text: 'Crear',
                        disabled: true,
                        href: '/asignacion/crear',
                        },
                        
                    ],

                },
            ]

        }
    }

  }
</script>